import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "py-14 text-center px-4 text-gray-500 text-lg" }
const _hoisted_3 = {
  key: 2,
  class: "py-14 text-center px-4 text-gray-500 text-lg"
}

import { computed, ref, watch } from 'vue';
import { cloneDeep } from 'lodash-es';
import GenericDashboard from '@/components/common/dashboard/GenericDashboard.vue';
import { ActionType } from '@/plugins/store/actions';
import { Dashboard, DashboardItem } from '@/types';
import { useStudyPeriodDashboard, StudyPeriodDashboardPayload } from '@/plugins/store/actions/queries/study-periods/dashboards';

interface Props {
    fetchState: (StudyPeriodDashboardPayload & { fetchIndex: number }) | null;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'TableTab',
  props: {
    fetchState: {}
  },
  setup(__props: any) {

const props = __props;

const computedFetchState = computed(() => {
    if (props.fetchState) {
        const { fetchIndex, ...payload } = props.fetchState;
        return payload;
    }

    return null;
});
const isQueryEnabled = computed(() => props.fetchState !== null);

const { data, isFetching, isError, refetch } = useStudyPeriodDashboard(computedFetchState, { enabled: isQueryEnabled });

const dashboard = ref<Dashboard | undefined>();

watch(
    data,
    (newData) => {
        dashboard.value = newData?.tables ? cloneDeep(newData.tables) : undefined;
    },
    { immediate: true }
);

watch(
    () => props.fetchState?.fetchIndex,
    (newValue, oldValue) => {
        if (newValue !== oldValue) {
            refetch();
        }
    }
);

function onUpdateItem({ item }: { item: DashboardItem }) {
    const itemIndex = dashboard.value!.items.findIndex((i) => i.item_no === item.item_no);

    if (itemIndex !== -1) {
        dashboard.value!.items[itemIndex] = item;
    }
}

function onUpdateSectionCollapse({ sectionIndex, isCollapsed }: { sectionIndex: number; isCollapsed: boolean }) {
    if (dashboard.value?.sections?.[sectionIndex]) {
        dashboard.value.sections[sectionIndex].is_collapsed = isCollapsed;
    }
}

return (_ctx: any,_cache: any) => {
  return (_unref(isError))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('views.monitoring.teamComparison.errors.couldNotLoadData')), 1)
      ]))
    : (dashboard.value || _unref(isFetching))
      ? (_openBlock(), _createBlock(GenericDashboard, {
          key: 1,
          data: dashboard.value,
          loading: _unref(isFetching),
          "fetch-params": computedFetchState.value,
          "fetch-action-type": _unref(ActionType).GetStudyPeriodsDashboard,
          "data-key": "tables",
          "persistent-loading": "",
          "no-data-text": _ctx.$t('views.monitoring.teamComparison.texts.noData'),
          "onUpdate:item": onUpdateItem,
          "onUpdate:sectionCollapse": onUpdateSectionCollapse
        }, null, 8, ["data", "loading", "fetch-params", "fetch-action-type", "no-data-text"]))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.$t('views.monitoring.teamComparison.texts.generateToViewInsight')), 1))
}
}

})